// import React, { useState } from 'react';
// import {
//     Box,
//     Button,
//     CircularProgress,
//     Container,
//     TextField,
//     Typography,
//     useTheme,
//     useMediaQuery
// } from '@mui/material';
// import { useNavigate } from 'react-router';
// import { userLogin } from '../Services/Services';
// import { storeToken, storeResponse, removeToken } from '../Services/LocalStorageService';

// function LoginPage() {
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [error, setError] = useState('');
//     const [loading, setLoading] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!email || !password) {
//             setError('⚠️ Please fill in both email and password.');
//             return;
//         }

//         try {
//             setLoading(true);
//             setError('');

//             const response = await userLogin({ email, password });

//             if (response?.token) {
//                 removeToken();
//                 storeToken(response.token);
//                 storeResponse(response.user);
//                 navigate('/dashboard');
//             } else {
//                 setError('❌ Invalid credentials. Please try again.');
//             }

//         } catch (err) {
//             if (err.response) {
//                 setError(`❌ Server error: ${err.response.data?.detail || 'Something went wrong.'}`);
//             } else if (err.request) {
//                 setError('❌ Network error: No response from server.');
//             } else {
//                 setError(`❌ Error: ${err.message}`);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 minHeight: '100vh',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 bgcolor: '#f5f5f5',
//                 px: 2,
//             }}
//         >
//             <Box
//                 sx={{
//                     width: isMobile ? '100%' : isTablet ? '70%' : '40%',
//                     boxShadow: 3,
//                     borderRadius: 2,
//                     p: 4,
//                     bgcolor: '#fff'
//                 }}
//             >
//                 <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
//                     Login
//                 </Typography>

//                 {error && (
//                     <Typography color="error" sx={{ mb: 2 }} align="center">
//                         {error}
//                     </Typography>
//                 )}

//                 <form onSubmit={handleSubmit}>
//                     <TextField
//                         label="Email"
//                         type="email"
//                         variant="outlined"
//                         fullWidth
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         margin="normal"
//                         required
//                     />
//                     <TextField
//                         label="Password"
//                         type="password"
//                         variant="outlined"
//                         fullWidth
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         margin="normal"
//                         required
//                     />
//                     <Button
//                         type="submit"
//                         variant="contained"
//                         fullWidth
//                         sx={{ mt: 2, borderRadius: 2 }}
//                         disabled={loading}
//                     >
//                         {loading ? <CircularProgress size={20} color="inherit" /> : 'Login'}
//                     </Button>
//                 </form>

//                 {/* Powered By Section */}
//                 <Box sx={{ mt: 4, bgcolor: '#e0e0e0', p: 2, borderRadius: 1 }}>
//                     <Typography
//                         variant="body2"
//                         align="center"
//                         fontWeight={500}
//                         sx={{ color: '#333' }}
//                     >
//                         Powered By:{' '}
//                         <a
//                             href="https://www.yashvitech.com/"
//                             target="_blank"
//                             rel="noreferrer"
//                             style={{ textDecoration: 'none', color: '#000' }}
//                         >
//                             YASHVITECH IT SOLUTION PVT. LTD.
//                         </a>
//                     </Typography>
//                 </Box>
//             </Box>
//         </Box>
//     );
// }

// export default LoginPage;







import React, { useState } from "react";
import Logo from "../Auth/LOGO5.png"
// import Background from "../Auth/bg img.webp"
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useNavigate } from "react-router";
import { userLogin } from "../Services/Services";
import {
  storeToken,
  storeResponse,
  removeToken,
} from "../Services/LocalStorageService";

function LoginPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("⚠️ Please fill in both email and password.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await userLogin({ email, password });

      if (response?.token) {
        removeToken();
        storeToken(response.token);
        storeResponse(response.user);
        navigate("/dashboard");
      } else {
        setError("❌ Invalid credentials. Please try again.");
      }
    } catch (err) {
      if (err.response) {
        setError(
          `❌ Server error: ${err.response.data?.detail || "Something went wrong."}`
        );
      } else if (err.request) {
        setError("❌ Network error: No response from server.");
      } else {
        setError(`❌ Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
        backgroundImage:
          "url('https://png.pngtree.com/thumb_back/fw800/background/20250910/pngtree-global-logistics-international-cargo-shipping-and-transportation-image_19173692.webp')", // Truck background image
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        "&:before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          bgcolor: "rgba(0,0,0,0.6)", // dark overlay
        },
      }}
    >

      <Box
        sx={{
          width: isMobile ? "100%" : isTablet ? "70%" : "420px",
          borderRadius: 4,
          p: 4,
          backdropFilter: "blur(12px)",
          bgcolor: "rgba(255, 255, 255, 0.08)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          textAlign: "center",
          color: "#fff",
          zIndex: 2,
        }}
      >
        {/* Icon + Brand */}
        {/* <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <LocalShippingIcon sx={{ fontSize: 60, color: "#ff9100" }} />
        </Box> */}

        <img src={Logo} width={"200px"}></img>

        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#fff", letterSpacing: "1px" }}
        >

        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: "#ddd", mt: "-42px", fontSize: "10px" }}>
          LOGISTICE & TRANSPORTER
        </Typography>

        {error && (
          <Typography sx={{ mb: 2, fontWeight: "bold", color: "#ff5252" }}>
            {error}
          </Typography>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            InputProps={{
              style: { color: "#fff" },
            }}
            InputLabelProps={{
              style: { color: "#bbb" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#888" },
                "&:hover fieldset": { borderColor: "#ff9100" },
                "&.Mui-focused fieldset": { borderColor: "#ff6f00" },
              },
              mb: 2,
            }}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
            InputProps={{
              style: { color: "#fff" },
            }}
            InputLabelProps={{
              style: { color: "#bbb" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#888" },
                "&:hover fieldset": { borderColor: "#ff9100" },
                "&.Mui-focused fieldset": { borderColor: "#ff6f00" },
              },
            }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              borderRadius: 3,
              bgcolor: "#ff9100",
              py: 1.5,
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "1px",
              transition: "0.3s",
              "&:hover": {
                bgcolor: "#ff6f00",
                transform: "scale(1.05)",
              },
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : "Login"}
          </Button>
        </form>

        {/* Footer */}
        <Box sx={{ mt: 4, p: 2, borderRadius: 2, bgcolor: "rgba(255,255,255,0.05)" }}>
          <Typography variant="body2" align="center" sx={{ color: "#bbb", fontWeight: "bold" }}>
            Powered By:{" "}
            <a
              href="https://www.yashvitech.com/"
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: "none",
                color: "white",
                fontWeight: "bold",
              }}
            >
              YASHVITECH IT SOLUTION PVT. LTD.
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;







